import { Box, Card, CardContent, IconButton, Popover, Typography } from '@mui/material';
import InputComponent from './Components/InputComponent';
import CheckboxComponent from './Components/CheckboxComponents';
import SelectComponent from './Components/SelectComponent';
import Radiocomponent from './Components/RadioComponent';
import Numbercomponent from './Components/NumberComponent';
// import PasswordComponent from './Components/PasswordComponents';
import FileComponent from './Components/FileComponent';
import CameraComponent from './Components/CameraComponents';

import DefaultForm from './DefaultForm';
import { InputComponents } from '../../../utilites/StepType';
import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import { FieldArray } from 'formik';
import DateComponents from './Components/DateComponents';
import EsignComponent from './Components/EsignComponent';
// import TextArrayComponent from './Components/TextArrayCompoent';
import SwitchComponent from './Components/SwitchComponent';

const StepperCardComponent = ({
  activeStep,
  values,
  onSubmit,
  setFieldValue,
  handleChange,
  handleBlur
}: {
  activeStep: number;
  values: any;
  onSubmit: any;
  setFieldValue: any;
  handleChange: any;
  handleBlur: any;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showFieldTypeSelector, setShowFieldTypeSelector] = useState(false);

  const openPopover = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>, showTypeSelector = false) => {
    setAnchorEl(event.currentTarget);
    setShowFieldTypeSelector(showTypeSelector);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const PopoverModal = ({ push }: any) => {
    return (
      <Popover open={openPopover} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <DefaultForm
          onAddField={(data) => {
            console.log('Child', data);

            const { type, label } = data;
            const fieldData = {
              question: label,
              description: '',
              inputComponent: type,
              options: []
            };
            push(fieldData);
            handleClose();
          }}
          showFieldTypeSelector={showFieldTypeSelector}
        />
      </Popover>
    );
  };

  const RenderFieldComponent = ({
    values,
    setFieldValue,
    index,
    handleChange,
    handleBlur,
    childIndex
  }: {
    values: any;
    index: number;
    setFieldValue: any;
    handleChange: any;
    handleBlur: any;
    childIndex: number;
  }) => {
    const handleInput = (data: any) => {
      console.log('Received from child input:', data);
    };

    let { fields } = values;
    switch (fields[activeStep].children[childIndex].inputComponent) {
      case InputComponents.TEXT:
        return <InputComponent {...{ values, setFieldValue, index, childIndex, handleChange, handleBlur }} onSubmit={handleInput} />;
      case InputComponents.NUMBER:
        return <Numbercomponent {...{ values, setFieldValue, index, childIndex, handleChange, handleBlur }} onSubmit={handleInput} />;
      case InputComponents.FILE:
        return <FileComponent {...{ values, setFieldValue, index, childIndex, handleChange, handleBlur }} onSubmit={handleInput} />;
      // case InputComponents.PASSWORD:
      //   return <PasswordComponent {...{ values, setFieldValue, index, childIndex, handleChange, handleBlur }} onSubmit={handleInput} />;
      case InputComponents.CHECKBOX:
        return <CheckboxComponent {...{ values, setFieldValue, index, childIndex, handleChange, handleBlur }} onSubmit={handleInput} />;
      case InputComponents.SELECT:
        return <SelectComponent {...{ values, setFieldValue, index, childIndex, handleChange, handleBlur }} onSubmit={onSubmit} />;
      case InputComponents.RADIO:
        return <Radiocomponent {...{ values, setFieldValue, index, childIndex, handleChange, handleBlur }} onSubmit={onSubmit} />;
      case InputComponents.CAMERA:
        return <CameraComponent {...{ values, setFieldValue, index, childIndex, handleChange, handleBlur }} onSubmit={onSubmit} />;

      default:
        return null;
      case InputComponents.DATE:
        return <DateComponents values={values} index={index} setFieldValue={setFieldValue} childIndex={childIndex} />;
      case InputComponents.ESIGN:
        return <EsignComponent values={values} setFieldValue={setFieldValue} index={index} childIndex={childIndex} />;
      // case InputComponents.TEXTARRAY:
        // return <TextArrayComponent values={values} setFieldValue={setFieldValue} index={index} childIndex={childIndex} />;
      case InputComponents.SWITCH:
        return (
          <SwitchComponent
            values={values}
            setFieldValue={setFieldValue}
            index={index}
            childIndex={childIndex}
            onSubmit={function (data: any): void {
              throw new Error('Function not implemented.');
            }}
            handleChange={function (e: any): void {
              throw new Error('Function not implemented.');
            }}
            handleBlur={function (e: any): void {
              throw new Error('Function not implemented.');
            }}
          />
        );
    }
  };

  return (
    <>
      <Card
        sx={{
          width: '100%',
          minHeight: '300px',
          maxHeight: 'auto',
          display: 'flex',
          flexDirection: 'column',
          mt: 1
        }}
      >
        {/* Header */}
        <CardContent
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            bgcolor: '#f5f5f5',
            borderBottom: '1px solid #e0e0e0',
            py: 2
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {values.fields[activeStep]?.question}
          </Typography>
          <IconButton size="medium" color="primary" onClick={(e) => handleClick(e, true)}>
            <AddIcon />
          </IconButton>
        </CardContent>

        {/* Body */}
        <CardContent
          sx={{
            maxHeight: '450px',
            overflowY: 'auto'
          }}
        >
          <FieldArray name={`fields.${activeStep}.children`} key={`child-form-${activeStep}`}>
            {({ push, remove }) => (
              <>
                {/* Popover form */}
                <PopoverModal push={push} />

                {values.fields[activeStep].children && values.fields[activeStep].children.length > 0 && (
                  <Box display="" flexDirection="row" justifyContent="start">
                    {/* Stepper */}
                    <Box>
                      {values.fields[activeStep].children.map((_: any, index: number) => (
                        <Box pt={4}>
                          <RenderFieldComponent
                            {...{ values, setFieldValue, index: activeStep, childIndex: index, handleChange, handleBlur }}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </>
            )}
          </FieldArray>
        </CardContent>
      </Card>
    </>
  );
};

export default StepperCardComponent;
